/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { cached } from '@glimmer/tracking';
import type { ModelRegistry } from 'ember-data/types/registries/model';

type DisputeEventKind =
  | 'opened'
  | 'withdrawn'
  | 'reinstated'
  | 'closed'
  | 'deadline';

interface IDisputeEvent {
  kind: DisputeEventKind;
  at: Date;
}

interface IArgs {
  dispute: ModelRegistry['dispute'];
}

interface UiProtectionDisputePanelTimelineSignature {
  Element: HTMLElement;

  Args: IArgs;
}

export default class UiProtectionDisputePanelTimelineComponent extends Component<UiProtectionDisputePanelTimelineSignature> {
  @cached
  get events(): IDisputeEvent[] {
    const dispute = this.args.dispute;

    const candidates: [DisputeEventKind, Date | undefined][] = [
      ['opened', dispute.openedAt],
      ['withdrawn', dispute.fundsWithdrawnAt],
      ['reinstated', dispute.fundsReinstatedAt],
      ['closed', dispute.closedAt],
      ['deadline', dispute.respondBy],
    ];

    return candidates
      .filter((entry): entry is [DisputeEventKind, Date] => !!entry[1])
      .map(([kind, at]) => ({ kind, at }))
      .sort((a, b) => a.at.getTime() - b.at.getTime());
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Ui::Protection::DisputePanel::Timeline': typeof UiProtectionDisputePanelTimelineComponent;
    'ui/protection/dispute-panel/timeline': typeof UiProtectionDisputePanelTimelineComponent;
  }
}
